import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  FiHome,
  FiMapPin,
  FiGrid,
  FiUsers,
  FiLayers,
  FiDollarSign,
  FiClipboard,
  FiCheckCircle,
  FiCoffee,
  FiBookOpen,
  FiSettings,
} from 'react-icons/fi';
import {
  HM_BASE_PATH,
  getHostelManagementMenuItems,
  useHmBasePath,
} from './hostelManagementMenuItems';
import { useHmPermission } from './useHmPermission';

const MENU_ICONS = {
  dashboard: FiHome,
  hostels: FiMapPin,
  'floors-rooms': FiGrid,
  residents: FiUsers,
  'dues-deck': FiLayers,
  receivables: FiDollarSign,
  outstanding: FiClipboard,
  payments: FiCheckCircle,
  'food-report': FiCoffee,
  'special-orders': FiClipboard,
  ledger: FiBookOpen,
  adminsettings: FiSettings,
};

const HostelManagementAppMenuBar = ({ basePath: basePathProp }) => {
  const location = useLocation();
  const contextBasePath = useHmBasePath();
  const basePath = basePathProp || contextBasePath || HM_BASE_PATH;
  const { nav, isOwner } = useHmPermission();
  const items = getHostelManagementMenuItems(basePath).filter((item) => {
    if (item.id === 'billing') return false;
    if (!item.navKey) return isOwner;
    return Boolean(nav[item.navKey]);
  });

  const isItemActive = (item) => {
    const current = location.pathname || '';
    if (item.id === 'dashboard') {
      return (
        current === basePath
        || current === `${basePath}/`
        || current === `${basePath}/dashboard`
      );
    }
    if (current === item.path) return true;
    return current.startsWith(`${item.path}/`);
  };

  return (
    <>
      <nav className="hidden lg:block bg-white border-b border-gray-200 sticky top-14 z-40 shadow-sm" aria-label="Hostel Management modules">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-1 overflow-x-auto py-2 -mx-1 px-1">
            {items.map((item) => {
              const Icon = MENU_ICONS[item.id] || FiHome;
              const active = isItemActive(item);
              return (
                <NavLink
                  key={item.id}
                  to={item.path}
                  title={item.label}
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                    active
                      ? 'bg-red-50 text-red-800 border border-red-100'
                      : 'text-gray-600 border border-transparent hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  <Icon className="w-4 h-4 shrink-0" />
                  <span>{item.label}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
      </nav>
    </>
  );
};

export default HostelManagementAppMenuBar;
